module.exports = __webpack_public_path__ + "img/gateway9.b6f3b1cb.png";